import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { DictionaryItem } from '../../../typings/common';
import { TagInputType, TagValue } from '../../../typings/tagCloudTargeting';
import { AddButtonDecorator } from '../../AddButtonDecorator/AddButtonDecorator';
import { TextInputDecorator } from '../../TextInputDecorator/TextInputDecorator';
import { TagEditor } from '../TagEditor/TagEditor';

import * as keyset from './TagAdd.i18n';

const i18n = i18nFactory(keyset);

export interface TagAddProps {
    isInputShown: boolean;
    onAddButtonClick: () => void;
    inputType?: TagInputType;
    onTagAdd: (value: string[], isTriggeredByBlur?: boolean) => void;
    suggestItems?: DictionaryItem[];
    index: number;
    onFocus?: () => void;
    onBlur?: () => void;
    onCancel: () => void;
    onRefChange?: (ref: React.RefObject<TextInputDecorator>) => void;
    onPaste?: (value: TagValue[]) => void;
}

export const TagAdd: React.FC<TagAddProps> = React.memo(props => {
    const {
        isInputShown,
        inputType,
        suggestItems,
        index,
        onAddButtonClick,
        onTagAdd,
        onFocus,
        onBlur,
        onCancel,
        onRefChange,
        onPaste
    } = props;

    if (isInputShown) {
        return (
            <TagEditor
                suggestItems={suggestItems}
                inputType={inputType}
                onSubmit={onTagAdd}
                onFocus={onFocus}
                onBlur={onBlur}
                index={index}
                onCancel={onCancel}
                onRefChange={onRefChange}
                onPaste={onPaste}
            />
        );
    }

    return <AddButtonDecorator onAddClick={onAddButtonClick} value={i18n('add')} theme={'clear'} />;
});
